import {observable, action} from 'mobx';
import base from '../../tool/base';
import { message } from 'antd';
import {InitStore} from "../init/InitStore";
export class OrderStore {
  @observable orderDatas = [];
  @observable loadingOrder = false;
  @observable addModal = {
    addWhere: "0",
    visible: false,
    title: "",
    datas: [],
    cloumns: []
  }

  @observable applyModal = {
    visible: false,
    title: "获取表单",
  }

  @observable routes = [];
  @observable pagination = {
    defaultCurrent: 1,
    total: 0,
    current: 1,
    showSizeChanger: true,
    showQuickJumper: true,
    pageSize:10,
  }
  @observable searchValue={
    appName:'',
    startDate:null,
    endDate:null
  }

  constructor(routing) {
    this.routing = routing;
    this.setPagination = this.setPagination.bind(this);
    this.getRoutes = this.getRoutes.bind(this);
  }

  @action
  callOrderData(params = {}) {
    if (!localStorage.me) {
      message.info("对不起，此功能暂无权限！请登录后使用！");
    } else {
      this.loadingOrder = true;
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : {role: ""};
      params.access_token = me.token.access_token;
      params.pageSize = this.pagination.pageSize;
      params = {...this.searchValue,...this.pagination,...params};
      base.callApi('/v3/order/get', 'POST', params, 'json', 'text').then((data) => {
        if(data.status === 'true') {
          let temp = data.list || [];
          temp.forEach(item => {
            item.selected = false;
            item.hasMore =  item.swList.length > 10;
            item.current = 1;
            item.pageSize = 10;
          });
          this.orderDatas = temp;
          this.pagination = {...this.pagination,total:data.count};
        } else {
          message.info(data.msg);
          localStorage.removeItem('me');
          InitStore.me = {};
        }
        this.loadingOrder = false;
      });
    }
  }

  setPagination(pagination) {
    this.pagination = pagination;
  }

  getRoutes(params) {
    this.routes = [{
      key: '1',
      breadcrumbName: '云商店',
      path: '/'
    }];
    if(params.id && params.id === 'all') {
      this.routes.push({
        key:'2',
        breadcrumbName:'全部应用',
        path: '/app/list'
      });
    } else if(params.id && params.id === 'workflow') {
      this.routes.push({
        key:'2',
        breadcrumbName:'流程表单',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'portal') {
      this.routes.push({
        key:'2',
        breadcrumbName:'门户应用',
        path: '/app/list'
      });
    }
    this.routes.push({
      key: '3',
      breadcrumbName: '我的订单',
      path:'/app/order'
    });
  }

  callAddWhereData(params, filter) {
    let where = "";
    if (params === "2") {
      this.addModal = {
        ...this.addModal, addWhere: "2", title: "项目", cloumns: [{
          title: '项目名称',
          dataIndex: 'name',
        }, {
          title: '项目类别',
          dataIndex: 'type',
        }]
      }
      where = "project";
    } else if (params === "3") {
      this.addModal = {
        ...this.addModal, addWhere: "3", title: "方案", cloumns: [{
          title: '方案名称',
          dataIndex: 'name',
        }]
      }
      where = "scheme";
    }
    setTimeout(() => {
      this.addModal = {...this.addModal, datas: require("../../mocks/" + where + "/datas_" + where + ".json")};
      if (filter && filter !== "") {
        console.log("filter:", filter);
        let temp = [];
        this.addModal.datas.filter(function (el) {
          if (el && el.name.indexOf(filter) >= 0) {
            console.log("el1:", el);
            temp.push(el);
          }
        });
        this.addModal = {...this.addModal, datas: temp};
      }
      this.addModal = {...this.addModal, visible: true};
    }, 300);
  }

  callToAddAPP(app, where) {
    //??todo:添加应用到相应选择
    console.log("----callToAddAPP", app, where);
  }

}


// WEBPACK FOOTER //
// ./src/stores/order/OrderStore.js